import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 3.6em;
  width: 100%;

  div.pagination-info {
    font-size: 1.4rem;
    color: var(--gray);
  }

  div.pagination-controllers {
    display: flex;
    align-items: center;
    justify-content: center;

    button.arrows {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0;
      width: 2.5rem;
      background: transparent;
      color: var(--gray);

      &:disabled {
        cursor: default;

        .chevron-icon {
          opacity: 0.2;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .pagination-info,
    .pagination-controllers .pagination-item button {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 680px) {
    flex-direction: column;
    gap: 0.4rem;
  }

  @media (max-width: 520px) {
    .pagination-info,
    .pagination-controllers .pagination-item button {
      font-size: 1rem;
    }
  }

  @media (max-width: 400px) {
    .pagination-info,
    .pagination-controllers .pagination-item button {
      font-size: 0.8rem;
    }
  }
`;
